const Voucher = {
  CreateVoucher: "Voucher.CreateVoucher",
  NewVoucher: "Voucher.NewVoucher",
  SeriesInactive: "Voucher.SeriesInactive",
  NotSumToZero: "Voucher.NotSumToZero",
  BalanceBefore: "Voucher.BalanceBefore",
  BalanceAfter: "Voucher.BalanceAfter",
  Change: "Voucher.Change",
  AccountBalance: "Voucher.AccountBalance",
  PostWithoutImage: "Voucher.PostWithoutImage",
  CreatedVoucher: "Voucher.CreatedVoucher",
  Book: "Voucher.Book",
  HasLockedAccounts: "Voucher.HasLockedAccounts",
  PeriodLocked: "Voucher.PeriodLocked",
  ContainsInactiveAccounts: "Voucher.ContainsInactiveAccounts",
  Difference: "Voucher.Difference",
  BookingDate: "Voucher.BookingDate",
  }
export default Voucher;